import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceingujrat() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Gujarat',
    heading: 'Aaryan Travels: Corporate Cab Services in Gujarat',
    headingDescription: ' Aaryan Travels provides reliable Corporate Cab Services in Gujarat, catering to businesses, manufacturing hubs, and corporate travelers across major cities like Ahmedabad, Vadodara, Surat, Rajkot, and Gandhinagar. Whether you need employee transportation, client pickups, airport transfers, or intercity travel between industrial zones, our fleet of sedans, SUVs, luxury cars, and tempo travellers ensures a professional and comfortable experience. With trained chauffeurs, GPS-enabled vehicles, monthly rental plans, and centralized billing, we offer customized mobility solutions for factories, IT parks, and corporate offices. From GIDC estates to corporate corridors, Aaryan Travels is your trusted partner for dependable corporate cab services across Gujarat with 24/7 availability.',

    top: 'Top Places to Visit in Gujarat with Aaryan Travels',

"topPlaces": [
  {
    "title": "Statue of Unity, Kevadia",
    "description": "The Statue of Unity is the world’s tallest statue at 182 meters, dedicated to Sardar Vallabhbhai Patel. Located near the Narmada River, it offers breathtaking panoramic views from its viewing gallery. The surrounding area includes a Valley of Flowers, laser light shows, and jungle safaris. Tourists also enjoy boating and the nearby Glow Garden. The Statue of Unity is Gujarat’s monumental tribute to unity and pride."
  },
  {
    "title": "Sabarmati Ashram, Ahmedabad",
    "description": "Sabarmati Ashram was the residence of Mahatma Gandhi and the starting point of the historic Dandi March. The peaceful retreat showcases his personal belongings, letters, and photographs. The serene environment along the Sabarmati River invites meditation and reflection. Visitors walk through exhibits that depict India’s freedom struggle. Sabarmati Ashram is Gujarat’s spiritual cradle of non-violence."
  },
  {
    "title": "Somnath Temple, Veraval",
    "description": "Somnath Temple is one of the 12 Jyotirlingas dedicated to Lord Shiva, standing gracefully on the Arabian Sea coast. The temple has been destroyed and rebuilt multiple times in history, symbolizing eternal resilience. Evening aarti and sound-and-light shows enhance its divine charm. Waves crash against the temple walls creating a mesmerizing backdrop. Somnath is Gujarat’s timeless beacon of faith."
  },
  {
    "title": "Dwarkadhish Temple, Dwarka",
    "description": "Dwarkadhish Temple is an ancient shrine dedicated to Lord Krishna, believed to be his kingdom during the Mahabharata era. The five-story temple stands on 72 pillars overlooking the Gomti River. Pilgrims take a sacred dip at the Gomti Ghat before entering. Evening aarti fills the atmosphere with devotion and music. Dwarkadhish Temple is Gujarat’s gateway to divine heritage."
  },
  {
    "title": "Gir National Park, Sasan Gir",
    "description": "Gir National Park is the only natural habitat of the Asiatic lions in the world. Jungle safaris offer thrilling chances to spot lions, leopards, deer, and exotic birds. The rugged landscape of teak forests and rocky hills adds adventure. Nature lovers enjoy peaceful sunrise drives. Gir is Gujarat’s majestic kingdom of wildlife."
  },
  {
    "title": "Rann of Kutch, Bhuj",
    "description": "The Great Rann of Kutch is a vast white salt desert that glows under the moonlight, creating a surreal dreamscape. The annual Rann Utsav brings colorful tents, folk dances, and camel rides under starlit skies. Visitors enjoy local handicrafts and traditional Kutchi hospitality. Sunrise and sunset transform the desert into shades of gold and silver. The Rann is Gujarat’s magical canvas of culture and nature."
  },
  {
    "title": "Sun Temple, Modhera",
    "description": "The Sun Temple of Modhera, built in the 11th century by King Bhima I, is dedicated to the Sun God. The magnificent stepwell and intricately carved sandstone pillars reflect divine craftsmanship. During equinox, the first rays of the sun illuminate the sanctum perfectly. The temple hosts the Modhera Dance Festival each year. The Sun Temple is Gujarat’s architectural gem of celestial brilliance."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "Champaner-Pavagadh is a UNESCO World Heritage Site featuring ancient mosques, stepwells, and temples scattered across hills and plains. The Kalika Mata Temple atop the hill attracts both pilgrims and trekkers. The blend of Hindu and Islamic architecture showcases historical harmony. Panoramic views from the top are breathtaking. Champaner-Pavagadh is Gujarat’s treasure of forgotten kingdoms."
  },
  {
    "title": "Saputara Hill Station",
    "description": "Saputara is Gujarat’s only hill station, nestled in the lush Sahyadri ranges. Tourists enjoy boating on Lake Saputara, ropeway rides, and viewpoints like Sunset Point. The tribal culture and handicraft centers offer rich local experiences. Cool weather makes it ideal for summer retreats. Saputara is Gujarat’s serene hill escape."
  },
  {
    "title": "Akshardham Temple, Gandhinagar",
    "description": "Akshardham Temple is a stunning pink sandstone complex dedicated to Lord Swaminarayan. The intricate carvings, musical fountain shows, and educational exhibits attract lakhs of visitors annually. The temple lawns and spiritual aura offer deep peace. Security and cleanliness are maintained excellently. Akshardham is Gujarat’s harmonious blend of culture and devotion."
  }
],


 "services": [
  {
    "name": "Corporate Cab Services in Gujarat",
    "description": "Our Corporate Cab Services in Gujarat offer comprehensive transportation solutions tailored for businesses across the state. Whether you need daily employee commutes, executive transfers, or outstation corporate travel, our fleet of well-maintained sedans and SUVs ensures comfort and punctuality. With professional chauffeurs, 24x7 availability, and flexible booking options including monthly rentals, we cater to all corporate mobility needs efficiently."
  },
  {
    "name": "Gujarat Business Taxi",
    "description": "Gujarat Business Taxi provides reliable and professional taxi services designed specifically for business travel. Whether for meetings, airport transfers, or client visits, our service ensures timely pickups, courteous drivers, and clean vehicles. Ideal for short trips or extended business travel, we focus on delivering convenience and safety at competitive prices."
  },
  {
    "name": "Office Cab Hire Gujarat",
    "description": "Office Cab Hire in Gujarat simplifies employee transportation with customized routes, shift-wise scheduling, and real-time tracking. Perfect for businesses seeking dependable daily commute solutions, our service helps reduce tardiness and boosts workforce productivity with safe and comfortable rides."
  },
  {
    "name": "Chauffeur Corporate Cabs Gujarat",
    "description": "Experience premium chauffeur-driven corporate cab services across Gujarat. Our trained drivers offer professional, discreet, and safe rides for executives and VIP clients. Choose from luxury sedans and SUVs, designed to provide a comfortable and stress-free travel experience for your business needs."
  },
  {
    "name": "Monthly Corporate Cab Gujarat",
    "description": "Monthly Corporate Cab plans in Gujarat offer cost-effective and flexible transportation options for businesses with ongoing travel needs. Benefit from fixed monthly rates, priority service, and hassle-free billing, ideal for employee commutes, client visits, and executive transfers throughout the region."
  },
  {
    "name": "Employee Transport Gujarat",
    "description": "Our Employee Transport services in Gujarat provide safe and efficient commute solutions for your workforce. With GPS-enabled vehicles, verified drivers, and optimized routes, we ensure timely pickups and drop-offs across multiple shifts, enhancing employee satisfaction and operational efficiency."
  },
  {
    "name": "Staff Cab Gujarat",
    "description": "Staff Cab services in Gujarat cater to the transportation needs of your company’s field teams, warehouse staff, and office employees. Offering a range of vehicles from hatchbacks to SUVs, we provide reliable rides with trained chauffeurs and transparent billing to keep your workforce moving smoothly."
  },
  {
    "name": "Gujarat Corporate Car Hire",
    "description": "Gujarat Corporate Car Hire delivers tailored vehicle rental solutions for businesses seeking flexibility and professionalism. Whether for short-term projects, events, or long-term contracts, our fleet of premium cars and SUVs ensures reliable and comfortable transportation."
  },
  {
    "name": "Affordable Corporate Cab Gujarat",
    "description": "Affordable Corporate Cab Gujarat provides budget-friendly yet quality transportation options for businesses. Perfect for startups and SMEs, our service guarantees punctuality, professional drivers, and well-maintained vehicles without compromising on comfort or safety."
  },
  {
    "name": "Executive Taxi Gujarat",
    "description": "Executive Taxi services in Gujarat offer luxury travel for top executives and VIP clients. Featuring high-end sedans and SUVs with modern amenities, our chauffeurs ensure a seamless, comfortable, and prestigious travel experience for your business engagements."
  },
  {
    "name": "Company Cab Services Gujarat",
    "description": "Company Cab Services across Gujarat provide dedicated transportation solutions for corporate clients. Whether for client meetings, team outings, or regular staff commutes, our service offers flexibility, reliability, and easy booking, making corporate travel hassle-free."
  },
  {
    "name": "Premium Corporate Cabs Gujarat",
    "description": "Premium Corporate Cabs in Gujarat focus on delivering luxurious and exclusive rides for discerning business travelers. Our fleet includes top-tier vehicles driven by professional chauffeurs who prioritize comfort, privacy, and timely arrivals."
  },
  {
    "name": "Best Corporate Taxi Gujarat",
    "description": "Recognized as one of the Best Corporate Taxi services in Gujarat, we pride ourselves on maintaining high standards of safety, professionalism, and customer satisfaction. Our corporate clients enjoy consistent service quality, transparent pricing, and prompt support."
  },
  {
    "name": "Online Booking Corporate Cab Gujarat",
    "description": "Our Online Booking platform for Corporate Cabs in Gujarat offers a seamless experience for scheduling and managing business travel. With real-time ride tracking, instant confirmations, and comprehensive billing, managing your corporate transportation has never been easier."
  },
  {
    "name": "Corporate Shuttle Gujarat",
    "description": "Corporate Shuttle services in Gujarat provide efficient group transport for large teams, tech parks, and industrial areas. Equipped with mini-buses and multi-utility vehicles, we offer scheduled routes ensuring punctuality, safety, and convenience for your staff."
  }
],
"tableData": [
  ["Corporate Cab Services in Gujarat", "Gujarat Business Taxi"],
  ["Office Cab Hire Gujarat", "Chauffeur Corporate Cabs Gujarat"],
  ["Monthly Corporate Cab Gujarat", "Employee Transport Gujarat"],
  ["Staff Cab Gujarat", "Gujarat Corporate Car Hire"],
  ["Affordable Corporate Cab Gujarat", "Executive Taxi Gujarat"],
  ["Company Cab Services Gujarat", "Premium Corporate Cabs Gujarat"],
  ["Best Corporate Taxi Gujarat", "Online Booking Corporate Cab Gujarat"],
  ["Corporate Shuttle Gujarat", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Cab Services Across Gujarat",
    "WhyChoosedescription": "Aaryan Travels offers professional corporate cab services covering major cities and industrial hubs throughout Gujarat."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Business Commutes",
    "WhyChoosedescription": "Ensure timely and hassle-free transportation for your employees and clients across Gujarat’s key business areas."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Corporate Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide comfort and professionalism."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Gujarat’s Routes",
    "WhyChoosedescription": "Our drivers are knowledgeable about major corporate and industrial routes across Gujarat for efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Corporate Billing and No Hidden Charges",
    "WhyChoosedescription": "Enjoy GST-compliant invoices and upfront pricing to simplify your corporate expense management."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Support for Corporate Clients",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, changes, and queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Tailored to Your Business Needs",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly cab hire contracts customized for your organization."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles for All Corporate Requirements",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers depending on your team size and travel preferences."
  }
]


































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab services in Gujarat?',
    answer: 'Yes, Aaryan Travels provides reliable and professional corporate cab services across major cities in Gujarat to meet your business travel needs.',
  },
  {
    question: 'How can I book corporate cab services in Gujarat with Aaryan Travels?',
    answer: 'You can book corporate cabs through our website, mobile app, or by contacting our dedicated corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Gujarat?',
    answer: 'We offer a wide range of vehicles including sedans, SUVs, and premium cars suitable for executive and employee transportation.',
  },
  {
    question: 'Are Aaryan Travels’ corporate cab services suitable for daily employee commute in Gujarat?',
    answer: 'Yes, we provide customized corporate cab solutions for daily employee pickups and drops in Gujarat.',
  },
  {
    question: 'Are your drivers trained and experienced for corporate travel in Gujarat?',
    answer: 'Absolutely. Our drivers are professional, courteous, and familiar with corporate travel requirements across Gujarat.',
  },
  {
    question: 'Can Aaryan Travels manage bulk or group cab bookings for corporate events in Gujarat?',
    answer: 'Yes, we specialize in handling group transportation and bulk cab bookings for corporate meetings, conferences, and events.',
  },
  {
    question: 'Do you offer monthly billing or invoicing options for corporate clients in Gujarat?',
    answer: 'Yes, we provide flexible billing options including monthly invoicing for corporate cab services.',
  },
  {
    question: 'Is your corporate cab service in Gujarat available 24x7?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to ensure seamless business travel.',
  },
  {
    question: 'What safety measures are followed for corporate cab services in Gujarat?',
    answer: 'All vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for corporate cab bookings in Gujarat?',
    answer: 'Yes, you can customize pickup and drop points based on your corporate travel needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patel',
    feedback: 'Aaryan Travels has consistently provided excellent corporate cab services across Gujarat. Highly professional and reliable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Desai',
    feedback: 'Our company trusts Aaryan Travels for all corporate cab requirements in Gujarat. Great service and support.',
    rating: 5,
  },
];






























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Gujarat",
  "image": "https://aaryantravels.com/assets/images/corporate-cab-gujarat.jpg", // replace with actual image URL
  "description": "Professional and affordable corporate cab services in Gujarat by Aaryan Travels. Ideal for business travel, staff transportation, and executive commutes with premium sedans and SUVs.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "2100", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1450",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/corporate-cab-services-gujarat"
  }
};








  return (
    <div>

<Helmet>
  <title>Corporate Cab Services in Gujarat | Business & Staff Transport | Aaryan Travels</title>
  <meta
    name="description"
    content="Professional and affordable corporate cab services in Gujarat by Aaryan Travels. Ideal for business travel, staff transportation, and executive commutes with premium sedans and SUVs."
  />
  <meta
    name="keywords"
    content="Corporate Cab Services in Gujarat, Gujarat Business Taxi, Office Cab Hire Gujarat, Chauffeur Corporate Cabs Gujarat, Monthly Corporate Cab Gujarat, Employee Transport Gujarat, Staff Cab Gujarat, Gujarat Corporate Car Hire, Affordable Corporate Cab Gujarat, Executive Taxi Gujarat, Company Cab Services Gujarat, Premium Corporate Cabs Gujarat, Best Corporate Taxi Gujarat, Online Booking Corporate Cab Gujarat, Corporate Shuttle Gujarat"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/35.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceingujrat;